import React from 'react';
import FieldComponent from '../../../b2b-common/FieldComponent';
import DatesRange from './DatesRange';
import { generateClassName } from '../../../b2b-common/helpers';
import useB2BTranslation from '../../../b2b-common/hooks/useB2BTranslation';
import { Remove } from '@mui/icons-material';

const DatesField = ({ startDate, endDate, className = null }) => {
    const { t } = useB2BTranslation('b2b-plans');
    return (
        <FieldComponent
            label={t('Start and End dates')}
            component={
                <DatesRange
                    startDate={startDate}
                    endDate={endDate}
                    showIcon={false}
                    showLabel={false}
                    showSeparator={true}
                    className={'dates-field-range'}
                    SeparatorIcon={Remove}
                />
            }
            className={generateClassName('dates-field', '-container', className)}
            labelAlign='left'
            componentAlign='left'
        />
    );
};

export default DatesField;